export class AppData {
  apiUrl: string;
  aiIKey: string;
  identityServerUrl: string;
  iceWebRootUrl: string;
  alertUrl: string;
  mannyBaseUrl: string;
  environment: string;
  clientVersion: string;
  enableEquipmentUpgradeUpgrade: string;
  salesCompetitionUrl: string;
  isReturnPhoneInStoreEnabled: string;
  orderServiceUrl: string;
  versionFile: string;
  versionCheckIntervalInMS: number;
  sanityProjectId: string;
  sanityDataset: string;
  salesForceUrl: string;
  baseUrl: string;
  webShopBaseUrl: string;
  iceNoBaseUrl: string;
}
